export default "__VITE_ASSET__92b713a3__"